<template>
  <div class="c-slideoutExternal m-menuSlideout m-menuSlideout--left">
    <div class="m-menuSlideout_wrapper">
      <header class="m-menuSlideout_header">
        <img class="m-menuSlideout_brand" :src="require('icon/custom/logo-color-white-horizontal.svg')" alt="logo do CoteiBem" title="Menu do sistema">
        <img class="m-menuSlideout_close" :src="require('icon/custom/modal-close.svg')" alt="fechar" title="fechar" @click="$emit('close')">
      </header>

      <scroll-lock>
        <div class="m-menuSlideout_content">
          <div class="m-menuList">

            <div class="m-menuList_item">
              <a class="m-menuList_link" title="Conheça as vantagens de usar CoteiBem" @click="showMenu()">
                <span class="m-menuList_text">Pedir orçamentos</span>
              </a>
            </div>

            <div class="m-menuList_item">
              <a class="m-menuList_link" :href="supplierUrl" title="Veja os depoimentos de quem já usou o CoteiBem" @click="$emit('close')">
                <span class="m-menuList_text">Seja um fornecedor</span>
              </a>
            </div>

            <div class="m-menuList_item">
              <a class="m-menuList_link" title="Acesse sua conta do CoteBem" :href="loginUrl">
                <span class="m-menuList_text">Entrar</span>
              </a>
            </div>

          </div>
          <!-- <div class="c-slideoutExternal_buttonWrap">
            <div
              class="m-button m-button--success c-slideoutExternal_button"
              @click="showMenu()"
              @keydown.enter="showMenu()"
              role="button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18.751" height="18.747" viewBox="0 0 18.751 18.747" v-bind:class="'m-button_icon m-button_icon--left'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g data-name="streamline-icon-shopping-cart@20x20"><path data-name="Caminho 3174" class="cls-1" d="M12.643 16.247H4.376a.625.625 0 110-1.25h8.267a.623.623 0 00.616-.52l2.2-12.917A1.87 1.87 0 0117.306 0h.82a.625.625 0 110 1.25h-.82a.623.623 0 00-.616.52l-2.198 12.915a1.87 1.87 0 01-1.849 1.562z"/><path data-name="Caminho 3175" class="cls-1" d="M5.938 18.747a.938.938 0 11.938-.937.939.939 0 01-.938.937z"/><path data-name="Caminho 3176" class="cls-1" d="M12.188 18.747a.938.938 0 11.938-.937.939.939 0 01-.938.937z"/><path data-name="Caminho 3177" class="cls-1" d="M14.337 12.497H4.276a3.12 3.12 0 01-3.03-2.366L.038 5.297a1.25 1.25 0 011.213-1.553h14.362a.625.625 0 010 1.25H1.251l1.208 4.834a1.872 1.872 0 001.817 1.419h10.061a.625.625 0 110 1.25z"/></g></svg>
              Pedir orçamentoss
          </div>
          </div> -->
        </div>
      </scroll-lock>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
const lpHeaderMenu = () => import('Components/Landing/LandingPage/lpHeaderMenu')
const scrollLock = () => import('Components/scrollLock')
import { openModal } from 'Services/vueModal'
import { account, landingSupplier, categoryDirectory, categoryQuotation } from 'routes'

const initialState = () => ({
  categoryUrl: categoryDirectory.index,
  quoteUrl: categoryQuotation.index,
  loginUrl: account.login,
  supplierUrl: landingSupplier.index,
})

export default {
  components: {
    scrollLock,
  },

  data() {
    return initialState()
  },

  methods: {
    ...mapActions({
      toggleMenu: 'navigation/toggleMenu'
    }),

    showMenu() {
      this.toggleMenu('category')
      this.$emit('close')
    },
  }
}
</script>

<style lang="scss">
@import "~css/_references";

.c-slideoutExternal {
  &_buttonWrap {
    margin: $v-gap-sm;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }

  &_button {
    font-weight: normal;
    font-size: 16px;
  }
}
</style>